const topMain = () => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    let sW = window.innerWidth;
    const jsSecMain = document.getElementById('jsSecMain');
    let video = jsSecMain.querySelector('.js_main_video');
    let mainTxt = jsSecMain.querySelector('.js_main_txt');
    let merit = jsSecMain.querySelector('.js-merit');

    video.play();

    setTimeout(() => {
      mainTxt.classList.add('act');
    }, 2000);

    if (sW > 750) {
      setTimeout(() => {
        merit.classList.add('act');
      }, 4000);
    }

  }

}
export default topMain;